"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const contents = (0, react_redux_1.useSelector)((state) => state.roomData.contents);
    if (!contents.length)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return (0, jsx_runtime_1.jsx)(ContentsDiv, { children: (0, html_react_parser_1.default)(contents) });
}
exports.default = default_1;
const ContentsDiv = styled_1.default.div `
  padding: 20px;
  background-color: white;
  word-break: break-all;
  > * {
    max-width: 100%;
    margin-bottom: 6px;
    font-size: 16px;
    line-height: 1.5;
    * {
      line-height: 1.5;
    }
  }
  figure:not(.media) {
    display: table;
    margin: 0 auto;
  }
  img {
    max-width: 100%;
  }
  .image_resized > img {
    width: 100%;
  }
  table {
    table-layout: fixed;
    width: 100%;
    height: 100%;
    border: 1px double #b3b3b3;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: hidden;
    td {
      border: 1px solid #bfbfbf;
      min-width: 2em;
      padding: 0.4em;
    }
  }
  .image-style-block-align-left {
    margin-left: 0;
  }
  .image-style-block-align-right {
    margin-right: 0;
  }
  hr {
    height: 4px;
    border: 0;
    margin: 15px 0;
    background: #dedede;
  }
`;
